import * as model from "@/model/prd/productionExecution/smelting/SmeltingProductQuality";
import { newEntityStoreHelper } from "@/store/common/entityModule";

import router from "@/router/index";

function newFilter(paginationFilter = {}) {
    var filter = Object.assign({}, paginationFilter, model.filter)
    return filter;
}


export default newEntityStoreHelper(() => new model.SmeltingProductQuality(), newFilter)
    .withStates({
        idReport: 2,

        baseModuleUrl: process.env.VUE_APP_PRODUCTION_API_URL + "production-service/prd"
    }) //TODO load at the application start    
    .withActions({  
        updateData(context, row){
            context.dispatch("api/get", {
                url: context.state.baseModuleUrl + "/smeltingProductQuality/updateData/" + row.planCode
            },{ root: true })
            .then(response => {
                //seting the values
                {
                    context.commit('smeltingProductQuality' + "/setRows", [response], { root: true });                                    
                }       
            });
        }
    })
    .buildStore()